export enum AuthStateEnum {
    Pending = 0,
    Authenticated = 1,
    Successful = 2,
    Failed = 3
}